import { useNavigate } from "@tanstack/react-router";
import { TabBar } from "@/components/ui/tab-bar";
import { ServicesCatalogSection } from "./ServicesCatalogSection";
import { TestsCatalogSection } from "./TestsCatalogSection";

export type CatalogTab = "services" | "tests";

export const CATALOG_TABS: Array<{ value: CatalogTab; label: string }> = [
  { value: "services", label: "Usluge" },
  { value: "tests", label: "Testovi" },
];

export function isCatalogTab(value: unknown): value is CatalogTab {
  return typeof value === "string" && CATALOG_TABS.some((t) => t.value === value);
}

export function CatalogPage({ tab }: { tab: CatalogTab }) {
  const navigate = useNavigate({ from: "/dashboard/admin/catalog" });
  const setTab = (next: string) => navigate({ search: { tab: next as CatalogTab } });

  return (
    <div className="mx-auto max-w-6xl space-y-5 pb-14 sm:space-y-6">
      <header>
        <h1
          className="text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          Katalog
        </h1>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          Platformske usluge i testovi koje terapeuti koriste.
        </p>
      </header>

      <div className="flex flex-col gap-3 border-b border-border/60 pb-3 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-lg font-semibold leading-none tracking-tight text-foreground" style={{ fontFamily: "var(--font-heading)" }}>
          Katalog platforme
        </h2>
        <TabBar
          tabs={CATALOG_TABS}
          value={tab}
          onChange={setTab}
          ariaLabel="Katalog platforme"
          mobileMode="scroll"
        />
      </div>

      <div className="min-w-0">
        {tab === "tests" ? <TestsCatalogSection /> : <ServicesCatalogSection />}
      </div>
    </div>
  );
}
